module.exports = __webpack_public_path__ + "static/media/keyIcon.15ffc310.svg";